module.exports = __webpack_public_path__ + "static/media/ServiceActivator-DarkBackground.da550127.png";